import {Checkbox} from '@mui/material';

type ChangeModuleListedSettingsProps = {
  selectedValue: boolean;
  handleChange: (newValue: boolean) => void;
};

function ChangeModuleListedSettings({selectedValue, handleChange}: ChangeModuleListedSettingsProps) {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-col gap-1">
        <h2 className="font-bold text-2xl text-gray-200">Module Public Listing</h2>
        <p>
          Modules that are publicly listed can be discovered by anyone on the platform in the
          <span className="italic"> &quot;Join a new module&quot; </span>section in the the Modules section of the
          Profile page. After requesting to join a publicly listed module, a Course-Admin will have to approve their
          request.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 select-none mt-2">
          {[
            {
              value: true,
              label: 'Publicly listed',
              description: 'Anyone on the platform can discover and request to join this module',
            },
            {
              value: false,
              label: 'Not publicly listed',
              description: 'Students can be only added manually by the Course-Admin',
            },
          ].map(({value, label, description}) => (
            <label
              key={value ? 'public' : 'private'}
              className="relative flex items-center p-4 rounded-lg shadow-sm border hover:shadow-md transition-all duration-200 cursor-pointer peer-checked:publicly-listed peer-checked:ring-black hover:bg-primary-main "
            >
              <input
                type="radio"
                name="listed"
                value={value.toString()}
                checked={selectedValue === value}
                onChange={() => handleChange(value)}
                className="hidden peer"
              />
              <div
                className={`absolute inset-0 rounded-lg opacity-0 peer-checked:opacity-100 transition bg-[#415D1D]`}
              />
              <Checkbox
                sx={{'& .MuiSvgIcon-root': {fontSize: 28}}}
                checked={selectedValue === value}
                onClick={(event) => handleChange((event.target as HTMLInputElement).value === 'true')}
                value={value}
              />
              <div className="ml-3 relative z-10">
                <label className="font-semibold text-lg">{label}</label>
                <p className="text-sm">{description}</p>
              </div>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ChangeModuleListedSettings;
